import { Component, OnInit } from '@angular/core';
import { Param } from '../../../../../models/param.model';
import { environment } from '../../../../../environments/environment';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { AllPromotion } from '../../../../../models/allPromotion.model';
import { IPromotion } from '../../../../../models/promotion.model';
import { CustomValidators } from '../../../../customValidators';
import { PromotionApplyService } from '../../../../../services/promotion_apply.service';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-promotions-offer-active',
  templateUrl: './all-promotions-offer-active.component.html',
  styleUrls: ['./all-promotions-offer-active.component.scss']
})
export class AllPromotionsOfferActiveComponent implements OnInit {
  sorted = false;
  sorted1 = false;
  sorted01 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  minValue: number = 100;
  maxValue: number = 1000000;
  perPage: number = 32;
  totalItems: number = 1000;
  currentPage: number = 1;
  totalPages!: number;
  searchForm: any;
  param: Param;
  annonceEnPromotionDeKahpoo:any[] = [];
  url_photo:any;
  search: any;
  allPromotions: any[] = [];
  allPromotionsTmp: any[] = [];
  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  endDateVal: any = null;
  disableEndDate: boolean = true;
  currentPromotion!: IPromotion;
  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  startDateNotBeforeDateNow = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  x_article_achete_y_article_offert1 = "x-article-achete-y-article-offert";
  x_pourcent_de_reduction1  = "x-pourcent-de-reduction";
  livraison_gratuite1 = "livraison-gratuite";
  livraison_gratuite_x_montant1 = "livraison-gratuite-a-partir-dun-x-montant-dachat";
  x_montant_reduit_sur_la_livraison_des_articles1 = "x-montant-reduit-sur-la-livraison-des-articles";
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction1 = "x-produit-achete-n-ieme-a-y-pourcent-de-reduction";


  constructor(private promotionApplyService: PromotionApplyService, private fb: FormBuilder,
              private location: Location, private router :Router) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.loadPromotions();
    
  }

  loadPromotions(){
    this.allKahpooPromotionsPosts(this.currentPage);
  }

  allKahpooPromotionsPosts = (page: number)=>{
      this.promotionApplyService.loadAllPromotionApplies(page-1, this.perPage).subscribe(posts=>{
          this.allPromotions = posts.content;
          this.allPromotionsTmp = posts.content;
          this.totalItems = posts.totalElements;
          this.perPage = posts.size;
          this.totalPages = posts.totalPages;
          // console.log("Annonce en promotions");
          // console.log(this.allPromotions);
        });
  }

  onViewPromo(promo: any) {
    this.currentPromotion = promo;
    // console.log(this.currentPromotion);
  }
  
  searchFilter($event: KeyboardEvent) {
    const searchQuery = this.search?.toLowerCase() || "";
    if (searchQuery) {
        this.allPromotions = this.allPromotionsTmp.filter(value =>
            value.shopName?.toLowerCase().includes(searchQuery) ||
            value.postSubProductID?.toLowerCase().includes(searchQuery) ||
            value.postServiceID?.toLowerCase().includes(searchQuery) ||
            value.postName?.toLowerCase().includes(searchQuery) ||
            value?.promotionItem?.name?.toLowerCase().includes(searchQuery)
        );
    }

    // console.log("this.allPromotions", this.allPromotions);
}


  displayPerPage(itemsPerPage: any) {
    // console.log("itemsPerPage", itemsPerPage)
    this.perPage = itemsPerPage;
    this.loadPromotions();
  }

  refresh() {
    let searchText = this.search !== undefined ? this.search : '';
    this.allKahpooPromotionsPosts(this.currentPage);
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  dateForm = this.fb.group({
    beginDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required])
  })

  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  enablePromotionApply(promo : any){
    Swal.fire({
      title: 'Voulez-vous activer cette promotion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.promotionApplyService.enablePromotionApply(promo?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Votre promotion a été activée avec succés.',
              showConfirmButton: false,
              timer: 3000
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
          }
        )
      }
    })
  }

  disablePromotionApply(promo: any){
    Swal.fire({
      title: 'Désactiver cette promotion.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.promotionApplyService.disablePromotionApply(promo.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Votre promotion a été désactivée avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
        })
      }
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  deletePromotion(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez vous vraiment supprimer cette promotion ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.promotionApplyService.deletePrmotionApplyByPostid(id).subscribe(
          rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La promotion a été supprimé avec succés',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadPromotions();
        },error =>{
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 4500
          });
        });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })
  }

  filterByDate() {

    if(this.dateForm.get('beginDate').invalid || this.dateForm.get('endDate').invalid){
      
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    
  }
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      // console.log("________________________________________________________________")
      // console.log(beginDate)
      // console.log("________________________________________________________________")
      // console.log(endDate)
      // console.log(this.allPromotions)
      if (beginDate === endDate) {
        this.allPromotions = this.allPromotions.filter(p => {
          // Conversion des dates en objets Date
          const startDate = new Date(p.startDate);
          const endDate = new Date(p.endDate);
      
          // Comparaison uniquement des parties jour/mois/année sans l'heure
          return (
            startDate.getFullYear() === endDate.getFullYear() &&
            startDate.getMonth() === endDate.getMonth() &&
            startDate.getDate() === endDate.getDate()
          );
        });
      }
      
    
      if (beginDate === endDate) {
        this.allPromotions = this.allPromotions.filter(p => {
          // Conversion des dates en objets Date
          const startDate = new Date(p.startDate);
          const endDate = new Date(p.endDate);
      
          // Comparaison uniquement des parties jour/mois/année sans l'heure
          return (
            startDate.getFullYear() === endDate.getFullYear() &&
            startDate.getMonth() === endDate.getMonth() &&
            startDate.getDate() === endDate.getDate()
          );
        });
      }else{
        this.promotionApplyService.loadAllPromotionApplies(this.currentPage - 1, this.perPage, beginDate, endDate).subscribe(data =>{
      
            this.allPromotions = data.content;
            this.totalItems = data.totalElements;
          
  
          // console.log("________________________________________________________________")
          // console.log(this.allPromotions)
        });
      }
     
    }
  }

  goBack(): void {
    this.location.back();
  }

  
  get getPost() { return this.postPromotionForm.controls; }

  postPromotionForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required, CustomValidators.startDateNotBeforeToday]),
    endDate : new FormControl("" , [Validators.required]),
  });
  
  getSelectedDate() {
    this.selectedStartDate = this.postPromotionForm.get('startDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }
  }

  getSelectedEndDate() {
    const startDateString = this.postPromotionForm.get('startDate')?.value;
    const endDateString = this.postPromotionForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.post?.title > b.post?.title ? 1 : a.post?.title < b.post?.title ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.post?.title < b.post?.title ? 1 : a.post?.title > b.post?.title ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort01() {
    if(this.sorted01 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.reference > b.reference ? 1 : a.reference < b.reference ? -1 : 0)
      this.sorted01 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.reference < b.reference ? 1 : a.reference > b.reference ? -1 : 0)
      this.sorted01 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.price > b.price ? 1 : a.price < b.price ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.price < b.price ? 1 : a.price > b.price ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.shopName > b.shopName ? 1 : a.shopName < b.shopName ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.shopName < b.shopName ? 1 : a.shopName > b.shopName ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.startDate > b.startDate ? 1 : a.startDate < b.startDate ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.startDate < b.startDate ? 1 : a.startDate > b.startDate ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.endDate > b.endDate ? 1 : a.endDate < b.endDate ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.endDate < b.endDate ? 1 : a.endDate > b.endDate ? -1 : 0)
      this.sorted5 = false;
    }
  }

  sort6() {
    if(this.sorted6 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.promotion?.promotionItem?.name > b?.promotion?.promotionItem?.name ? 1 : a?.promotion?.promotionItem?.name < b?.promotion?.promotionItem?.name ? -1 : 0)
      this.sorted6 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.promotion?.promotionItem?.name < b?.promotion?.promotionItem?.name ? 1 : a?.promotion?.promotionItem?.name > b?.promotion?.promotionItem?.name ? -1 : 0)
      this.sorted6 = false;
    }
  }

  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  strUcFirst2(valeur : any){
    if(valeur != undefined && valeur?.promotionItem.typeOffer?.slug){
      return valeur?.promotionItem?.typeOffer?.slug;
    }
  }

  strUcFirst22(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem?.value0
    }
  }

  strUcFirst33(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem?.value1
    }
  }

  strUcFirst44(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem?.value2
    }
  }


  strUcFirst3(valeur : any){
    if(valeur != undefined && valeur?.promotionItem.typeOffer){
      return valeur?.promotionItem?.typeOffer;
    }
  }

}
